module.exports = __webpack_public_path__ + "img/img-identity-2.eccacd06.svg";